import React, { useState, useEffect } from "react";
import {
  BookOpen,
  Users,
  Award,
  Code,
  Gamepad2,
  Smartphone,
  Globe,
  Star,
  CheckCircle,
  Clock,
  Trophy,
  Target,
} from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
// eslint-disable-next-line
import img2 from "../../assets/image/trainig/creative-people-sitting-table-boardroom_171337-5926.avif";
import "../../assets/css/trainingprogram.css";
import Footer from "../Footer/Footer";
import { FaUnity } from "react-icons/fa6";
import { SiUnrealengine, SiCocos } from "react-icons/si";
import { PiDroneBold  } from "react-icons/pi";
import { IoLogoAndroid } from "react-icons/io";
import { TbBrandReactNative } from "react-icons/tb";
import { RiFlutterFill, RiReactjsFill } from "react-icons/ri";
import { IoLogoAngular } from "react-icons/io5";
import { AiTwotoneHtml5 } from "react-icons/ai";

import {
  FaEnvelope,
  FaSkype,
  FaPhone,
  FaUser,
  FaGlobe,
  FaDollarSign,
  FaChartLine,
  FaPen,
  FaPaperPlane,
  FaBuilding,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";

const TrainingPrograms = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    const Gamedevelopment = data[0]?.services_page_Training_Programs;

    if (Gamedevelopment) {
      setMeta(Gamedevelopment);
    }
  }, []);
  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);

  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const form = useRef();

  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_z73r4mc",
        "template_evcmg1l",
        form.current,
        "EscxBRJBS9wDUay2E"
      )
      .then(
        (result) => {
          alert("Enquiry sent successfully!");
          setIsOpenEnquiry(false);
          setFormDataEnquiry({
            name: "",
            email: "",
            phone: "",
            whatsapp: "",
            companyName: "",
            companyService: "",
            serviceType: "",
            country: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send enquiry. Please try again.");
        }
      );
  };
  const [hoveredCard, setHoveredCard] = useState(null);
  const [activeTab, setActiveTab] = useState("drone-training");

  // Scroll Up
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      mirror: false,
      offset: 120,
      delay: 0,
    });

    // Refresh AOS when component mounts
    AOS.refresh();

    // Cleanup
    return () => {
      AOS.refreshHard();
    };
  }, []);

  // Refresh AOS when activeTab changes
  useEffect(() => {
    setTimeout(() => {
      AOS.refresh();
    }, 100);
  }, [activeTab]);

  // Training program categories
  const trainingCategories = [
    {
      id: "drone-training",
      title: "Drone Training",
      icon: <PiDroneBold  size={40} />, // you can replace with a drone icon if available
      description: "Master drone technology, piloting, and real-world applications",
      color: "#00b7eb",
      gradient: "#00b7eb",
      programs: [
        {
          name: "Drone Piloting",
          duration: "4 weeks",
          level: "Beginner",
          features: [
            "Basic Flight Controls",
            "Safety Guidelines",
            "Drone Regulations",
            "Hands-on Flying Practice",
          ],
          button: "Enroll Now",
        },
        {
          name: "Drone Integration and Maintenance",
          duration: "6 weeks",
          level: "Intermediate",
          features: [
            "Hardware Components",
            "Troubleshooting",
            "Repair Techniques",
            "System Integration",
          ],
          button: "Enroll Now",
        },
        {
          name: "FPV Drone Building",
          duration: "5 weeks",
          level: "Intermediate",
          features: [
            "Drone Assembly",
            "FPV Systems",
            "Controller Setup",
            "Testing & Calibration",
          ],
          button: "Enroll Now",
        },
        {
          name: "FPV Drone Piloting",
          duration: "4 weeks",
          level: "Intermediate",
          features: [
            "FPV Flying Techniques",
            "Racing Skills",
            "Camera Control",
            "Advanced Maneuvers",
          ],
          button: "Enroll Now",
        },
        {
          name: "Agricultural Drone Building & Piloting",
          duration: "6 weeks",
          level: "Advanced",
          features: [
            "Crop Spraying Systems",
            "Precision Farming",
            "Flight Planning",
            "Field Operations",
          ],
          button: "Enroll Now",
        },
        {
          name: "Industrial Inspection using Drones",
          duration: "5 weeks",
          level: "Advanced",
          features: [
            "Infrastructure Inspection",
            "Thermal Imaging",
            "Data Capture",
            "Safety Compliance",
          ],
          button: "Enroll Now",
        },
        {
          name: "Aerial Photography & Videography",
          duration: "4 weeks",
          level: "Beginner to Intermediate",
          features: [
            "Camera Settings",
            "Cinematography",
            "Editing Basics",
            "Creative Shots",
          ],
          button: "Enroll Now",
        },
        {
          name: "Drone Survey & Mapping",
          duration: "6 weeks",
          level: "Advanced",
          features: [
            "GIS Basics",
            "Mapping Tools",
            "Survey Techniques",
            "Data Processing",
          ],
          button: "Enroll Now",
        },
        {
          name: "Drone and GIS",
          duration: "5 weeks",
          level: "Advanced",
          features: [
            "Geospatial Analysis",
            "GIS Software",
            "Data Visualization",
            "Real-world Projects",
          ],
          button: "Enroll Now",
        },
        {
          name: "Drone Data & AI",
          duration: "6 weeks",
          level: "Advanced",
          features: [
            "AI for Drones",
            "Data Analytics",
            "Automation",
            "Machine Learning Basics",
          ],
          button: "Enroll Now",
        },
      ],
    },
    {
      id: "mobile-dev",
      title: "Mobile App Development",
      icon: <Smartphone size={40} />,
      description: "Build powerful mobile applications for iOS and Android",
      color: "#00b7eb",
      gradient: "#00b7eb",
      programs: [
        {
          name: "iOS Development with Swift",
          icon: <PiDroneBold  size={40} />,
          duration: "10 weeks",
          level: "Beginner to Advanced",
          features: [
            "Swift Programming",
            "iOS SDK",
            "UI/UX Design",
            "Core Data",
            "App Store Publishing",
          ],
          button: "Enroll Now",
        },
        {
          name: "Android Development with Java",
          icon: <IoLogoAndroid size={40} />,
          duration: "10 weeks",
          level: "Beginner to Advanced",
          features: [
            "Java Programming",
            "Android SDK",
            "Material Design",
            "Database Integration",
            "Google Play Store",
          ],
          button: "Enroll Now",
        },
        {
          name: "React Native Development",
          icon: <TbBrandReactNative size={40} />,
          duration: "8 weeks",
          level: "Intermediate",
          features: [
            "Cross-platform Development",
            "JavaScript/TypeScript",
            "Native Modules",
            "State Management",
            "Performance Optimization",
          ],
          button: "Enroll Now",
        },
        {
          name: "Flutter Development",
          icon: <RiFlutterFill size={40} />,
          duration: "8 weeks",
          level: "Beginner to Intermediate",
          features: [
            "Dart Programming",
            "Widget Development",
            "State Management",
            "Firebase Integration",
            "Cross-platform UI",
          ],
          button: "Enroll Now",
        },
      ],
    },
    {
      id: "web-dev",
      title: "Web Development",
      icon: <Globe size={40} />,
      description: "Create modern, responsive web applications",
      color: "#00b7eb",
      gradient: "00b7eb",
      programs: [
        {
          name: "Angular Development",
          icon: <IoLogoAngular size={40} />,
          duration: "10 weeks",
          level: "Intermediate to Advanced",
          features: [
            "TypeScript",
            "Component Architecture",
            "RxJS",
            "Angular CLI",
            "Testing & Deployment",
          ],
          button: "Enroll Now",
        },
        {
          name: "ReactJS Development",
          icon: <RiReactjsFill size={40} />,
          duration: "9 weeks",
          level: "Beginner to Advanced",
          features: [
            "Modern JavaScript",
            "Component Lifecycle",
            "State Management",
            "Hooks",
            "Performance Optimization",
          ],
          button: "Enroll Now",
        },
        {
          name: "HTML5 & Modern Web",
          icon: <AiTwotoneHtml5 size={40} />,
          duration: "6 weeks",
          level: "Beginner",
          features: [
            "Semantic HTML5",
            "CSS3 & Flexbox",
            "JavaScript ES6+",
            "Responsive Design",
            "Web APIs",
          ],
          button: "Enroll Now",
        },
      ],
    },
  ];

  // Key features of training programs
  const keyFeatures = [
    {
      icon: <Users size={40} />,
      title: "Expert-Led Sessions",
      description:
        "Learn from industry veterans with real-world experience and actionable insights from successful projects.",
    },
    {
      icon: <Code size={40} />,
      title: "Hands-On Learning",
      description:
        "Emphasizing labs, projects, and workshops that allow participants to apply new skills immediately.",
    },
    {
      icon: <Target size={40} />,
      title: "Production-Based Training",
      description:
        "Tailored programs that align with your current projects and future ambitions for maximum relevance.",
    },
    {
      icon: <Award size={40} />,
      title: "Certification & Assessment",
      description:
        "Validate skill levels with comprehensive assessments and industry-recognized certifications.",
    },
  ];

  // Statistics
  const stats = [
    { number: "500+", label: "Students Trained", icon: <Users size={30} /> },
    { number: "15+", label: "Expert Instructors", icon: <Star size={30} /> },
    { number: "20+", label: "Course Modules", icon: <BookOpen size={30} /> },
    { number: "95%", label: "Success Rate", icon: <Trophy size={30} /> },
  ];

  const currentCategory = trainingCategories.find(
    (cat) => cat.id === activeTab
  );

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>
      <div style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>{meta?.title || "Services-Trainings - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
          <meta
            name="description"
            content={meta?.meta?.meta1?.content || "Our curriculum."}
          />
        </Helmet>
        {/* Enquiry Form */}
        {isOpenEnquiry && (
          <div
            onClick={handleBackdropClick}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(8px)",
              zIndex: 1050,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                maxHeight: "100vh",
                background: "#fff",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Fixed Header */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#00b7eb",
                  color: "#ffffff",
                  padding: "15px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    textAlign: "center",
                  }}
                >
                  Enquiry Form
                </h3>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#ffffff",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Scrollable Form */}
              <div
                style={{
                  padding: "20px",
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 70px)", // Adjust based on header height
                }}
              >
                <form ref={form} onSubmit={handleSubmitForm}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {/* Full Name */}
                    <div>
                      <FaUser
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formDataEnquiry.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter full name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <FaEnvelope
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formDataEnquiry.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email"
                        style={inputStyle}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <FaPhone
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formDataEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone"
                        style={inputStyle}
                      />
                    </div>

                    {/* WhatsApp */}
                    <div>
                      <IoLogoWhatsapp
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">WhatsApp</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formDataEnquiry.whatsapp}
                        onChange={handleInputChange}
                        placeholder="Enter WhatsApp"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Name */}
                    <div>
                      <FaBuilding
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        value={formDataEnquiry.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Service */}
                    <div>
                      <IoMdBuild
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Service</label>
                      <select
                        name="companyService"
                        value={formDataEnquiry.companyService}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt</option>
                        <option value="LLP">LLP</option>
                        <option value="Startup">Startup</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>

                    {/* Service Type */}
                    <div>
                      <MdOutlineMiscellaneousServices
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Type of Service</label>
                      <select
                        name="serviceType"
                        value={formDataEnquiry.serviceType}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Drone">Drone Solutions</option>
                        <option value="Robotics">Robotics Solutions</option>
                        <option value="IOT">Iot Solutions</option>
                        <option value="AI">Artificial Intelligence</option>
                        <option value="Software">Software Development</option>
                        <option value="App">App Development</option>
                        {/* <option value="Game">Game Development</option> */}
                        <option value="Website">Website Development</option>
                        <option value="AR & VR Development">
                          AR & VR Apps
                        </option>
                        {/* <option value="Casino Api">Casino API</option> */}
                        {/* <option value="Devops Solutions">DevOps</option> */}
                        {/* <option value="It Support">IT Support</option> */}
                        <option value="Training Programs">Training</option>
                        {/* <option value="Digital Marketing">
                          Digital Marketing
                        </option> */}
                      </select>
                    </div>

                    {/* Country */}
                    <div>
                      <FaGlobe
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formDataEnquiry.country}
                        onChange={handleInputChange}
                        placeholder="Enter country"
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formDataEnquiry.message}
                      onChange={handleInputChange}
                      required
                      rows={1}
                      placeholder="Tell us about your requirements..."
                      style={{
                        ...inputStyle,
                        resize: "vertical",
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div
                    className="mt-1 margin-top-home"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      type="submit"
                      style={{
                        background: "#00b7eb",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "25px",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaPaperPlane style={{ marginRight: "8px" }} />
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
          {/* Hero Section */}
          <section
            className="position-relative min-vh-50 training-bg d-flex align-items-center justify-content-center text-white"
            data-aos="fade-in"
            data-aos-duration="1000"
          >
            <div className="devops-content container position-relative">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <nav
                    aria-label="breadcrumb"
                    className="mb-4"
                    data-aos="fade-right"
                    data-aos-delay="200"
                  >
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="/" className="text-light text-decoration-none">
                          Home
                        </a>
                      </li>
                      <li className="breadcrumb-item" aria-current="page">
                        Training Programs
                      </li>
                    </ol>
                  </nav>
                  <h3
                    className="display-5 fw-bold mb-3"
                    data-aos="fade-right"
                    data-aos-delay="400"
                  >
                    Training Programs
                  </h3>
                </div>
              </div>
            </div>
          </section>

          {/* Hero Content Section */}
          <section
            className="position-relative py-5"
            style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
              borderBottom: "1px solid #e2e8f0",
            }}
          >
            <div className="container">
              <div className="row align-items-center gy-5">
                {/* Left Section: Text */}
                <div className="col-lg-6 text-center text-lg-start">
                  <h3
                    className="display-5 fw-bold mb-3"
                    style={{ color: "#050708" }}
                    data-aos="fade-right"
                    data-aos-delay="200"
                  >
                    Empower Your Team with
                    <span style={{ color: "#00b7eb" }}> Expert Training</span>
                  </h3>
                  <p
                    className="font-para mb-4"
                    s
                    data-aos="fade-right"
                    data-aos-delay="400"
                  >
                    Comprehensive courses that blend theoretical knowledge with
                    practical, hands-on experience to excel in today's
                    competitive digital landscape.
                  </p>
                  <button
                    className="btn btn-red text-white fw-semibold px-3 py-2"
                    onClick={() => setIsOpenEnquiry(true)}
                  >
                    Explore Programs
                  </button>
                </div>

                {/* Right Section: Image */}
                <div className="col-lg-6 text-center">
                  <div
                    className="position-relative"
                    data-aos="fade-left"
                    data-aos-delay="300"
                  >
                    <div
                      className="rounded-3 mx-auto p-3"
                      style={{
                        // background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
                        // border: "1px solid #e0f2fe",
                        maxWidth: "100%",
                      }}
                    >
                      <img
                        src={img2}
                        alt="Training Illustration"
                        className="img-fluid rounded-3"
                        style={{
                          width: "100%",
                          maxWidth: "500px",
                          height: "auto",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Statistics Section */}
          <section className="py-5" style={{ backgroundColor: "#ffffff" }}>
            <div className="container">
              <div className="row g-4">
                {stats.map((stat, index) => (
                  <div key={index} className="col-lg-3 col-md-6">
                    <div
                      className="text-center p-4 h-100 rounded-3"
                      style={{
                        background:
                          "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                        border: "1px solid #e2e8f0",
                        transition: "all 0.3s ease",
                      }}
                      data-aos="fade-up"
                      data-aos-delay={index * 150}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0,0,0,0.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      <div
                        className="mb-3"
                        style={{ color: "#00b7eb " }}
                        data-aos="zoom-in"
                        data-aos-delay={index * 150 + 200}
                      >
                        {stat.icon}
                      </div>
                      <h3
                        className="display-5 fw-bold mb-2"
                        style={{ color: "#1e293b" }}
                        data-aos="fade-up"
                        data-aos-delay={index * 150 + 300}
                      >
                        {stat.number}
                      </h3>
                      <p
                        className="mb-0"
                        style={{ color: "#64748b" }}
                        data-aos="fade-up"
                        data-aos-delay={index * 150 + 400}
                      >
                        {stat.label}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Key Features Section */}
          <section className="py-4" style={{ backgroundColor: "#f8f9fa" }}>
            <div className="container">
              <div
                className="text-center mb-5"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <h3 className="display-5 fw-bold mb-3 font-black">
                  Why Choose Our
                  <span className="font-red"> Training Programs?</span>
                </h3>
                <p className="font-para">
                  Designed to inspire innovation and foster a culture of
                  continuous learning
                </p>
              </div>
              <div className="row g-4">
                {keyFeatures.map((feature, index) => (
                  <div key={index} className="col-lg-6">
                    <div
                      className="d-flex p-4 h-100 rounded-3"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e2e8f0",
                        transition: "all 0.3s ease",
                      }}
                      data-aos="fade-up"
                      data-aos-delay={index * 200 + 200}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-3px)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0,0,0,0.08)";
                        e.currentTarget.style.borderColor = "#00b7eb";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                        e.currentTarget.style.borderColor = "#e2e8f0";
                      }}
                    >
                      <div className="me-4">
                        <div
                          className="rounded-3 p-3 d-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#f0f9ff",
                            color: "#00b7eb",
                            width: "80px",
                            height: "80px",
                          }}
                          data-aos="zoom-in"
                          data-aos-delay={index * 200 + 400}
                        >
                          {feature.icon}
                        </div>
                      </div>
                      <div>
                        <h4
                          className="fw-bold mb-2"
                          style={{ color: "#1e293b" }}
                          data-aos="fade-left"
                          data-aos-delay={index * 200 + 300}
                        >
                          {feature.title}
                        </h4>
                        <p
                          className="font-para"
                          style={{ color: "#64748b", lineHeight: "1.6" }}
                          data-aos="fade-left"
                          data-aos-delay={index * 200 + 500}
                        >
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Training Categories Section */}
          <section className="py-4" style={{ backgroundColor: "#ffffff" }}>
            <div className="container">
              <div
                className="text-center mb-5"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <h3 className="display-5 fw-bold mb-3 font-black">
                  Our Training <span className="font-red">Categories</span>
                </h3>
                <p className="font-para mb-4">
                  Comprehensive curriculum covering the latest technologies and
                  industry best practices
                </p>
              </div>

              {/* Tab Navigation */}
              <div
                className="container"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="row justify-content-center g-3 mb-4">
                  {trainingCategories.map((category, index) => (
                    <div
                      key={category.id}
                      className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center"
                      data-aos="fade-up"
                      data-aos-delay={index * 100 + 300}
                    >
                      <button
                        type="button"
                        className="btn fw-semibold w-100 px-3 py-2"
                        style={{
                          backgroundColor:
                            activeTab === category.id
                              ? category.color
                              : "transparent",
                          color:
                            activeTab === category.id
                              ? "white"
                              : category.color,
                          border: `2px solid ${category.color}`,
                          borderRadius: "12px",
                          transition: "all 0.3s ease",
                        }}
                        onClick={() => setActiveTab(category.id)}
                      >
                        <span className="me-2">{category.icon}</span>
                        {category.title}
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              {/* Active Category Content */}
              {currentCategory && (
                <div>
                  <div
                    className="text-center mb-5"
                    data-aos="fade-in"
                    data-aos-delay="100"
                  >
                    {/* <h3
                      className="h6 fw-bold mb-3"
                      style={{ color: "#00b7eb" }}
                    >
                      {currentCategory.title}
                    </h3> */}
                    <p className="font-para">{currentCategory.description}</p>
                  </div>

                  <div className="row g-4">
                    {currentCategory.programs.map((program, index) => (
                      <div key={index} className="col-lg-4 col-md-6">
                        <div
                          className="card h-100 border-1 rounded-3"
                          style={{
                            transform:
                              hoveredCard === `${activeTab}-${index}`
                                ? "translateY(-8px)"
                                : "translateY(0)",
                            border: `1px solid ${hoveredCard === `${activeTab}-${index}`
                              ? currentCategory.color + "40"
                              : "#00b7eb"
                              }`,
                            transition: "all 0.3s ease",
                            boxShadow:
                              hoveredCard === `${activeTab}-${index}`
                                ? "0 20px 40px rgba(0,0,0,0.1)"
                                : "0 2px 10px rgba(0,0,0,0.05)",
                          }}
                          data-aos="fade-up"
                          data-aos-delay={index * 150 + 200}
                          onMouseEnter={() =>
                            setHoveredCard(`${activeTab}-${index}`)
                          }
                          onMouseLeave={() => setHoveredCard(null)}
                        >
                          {/* Card Body with Flex Column */}
                          <div className="card-body p-4 d-flex flex-column">
                            <div
                              className="d-flex align-items-center mb-3"
                              data-aos="fade-right"
                              data-aos-delay={index * 150 + 300}
                            >
                              <div className="rounded-2 p-3 me-3 bg-light text-dark">
                                {program.icon}
                              </div>
                              <div>
                                <h5 className="card-title font-black me-5 fs-3 fw-bold mb-1">
                                  {program.name}
                                </h5>
                                <div className="d-flex align-items-center">
                                  <Clock
                                    size={16}
                                    className="me-2"
                                    style={{ color: "#64748b" }}
                                  />
                                  <small style={{ color: "#64748b" }}>
                                    {program.duration}
                                  </small>
                                </div>
                              </div>
                            </div>

                            <div
                              className="mb-3"
                              data-aos="fade-in"
                              data-aos-delay={index * 150 + 400}
                            ></div>

                            <div
                              className="mb-4"
                              data-aos="fade-up"
                              data-aos-delay={index * 150 + 500}
                            >
                              <h6 className="fw-bold font-black mb-3">
                                What You'll Learn:
                              </h6>
                              {program.features.map((feature, idx) => (
                                <div
                                  key={idx}
                                  className="d-flex align-items-center mb-2"
                                  data-aos="fade-left"
                                  data-aos-delay={index * 150 + 600 + idx * 50}
                                >
                                  <CheckCircle
                                    size={16}
                                    className="me-2"
                                    style={{ color: "#00b7eb" }}
                                  />
                                  <small className="font-black">
                                    {feature}
                                  </small>
                                </div>
                              ))}
                            </div>

                            {/* Aligned Button - pushed to bottom */}
                            <div className="border-0 text-center d-flex justify-content-center mt-auto">
                              <button className="btn bg-red w-20 fw-bold rounded-3 mt-3 px-4 py-2 text-white">
                                {program.button}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </section>

          {/* Custom Styles */}
          {/* <style>{`
        .btn-group .btn {
          margin-right: 8px;
        }

        .btn-group .btn:last-child {
          margin-right: 0;
        }

        .card {
          overflow: hidden;
        }

        [data-aos="fade-in"] {
          opacity: 0;
          transition-property: opacity;
        }

        [data-aos="fade-in"].aos-animate {
          opacity: 1;
        }

        html {
          scroll-behavior: smooth;
        }

        @media (max-width: 768px) {
          .btn-group {
            flex-direction: column;
            width: 100%;
          }

          .btn-group .btn {
            margin-right: 0;
            margin-bottom: 8px;
            width: 100%;
          }

          .display-4 {
            font-size: 2.5rem;
          }

          .display-5 {
            font-size: 2rem;
          }
        }

        @media (max-width: 576px) {
          .display-4 {
            font-size: 2rem;
          }

          .display-5 {
            font-size: 1.75rem;
          }

          .lead {
            font-size: 1.1rem;
          }
        }
      `}</style> */}
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default TrainingPrograms;
